import { TApplicationState } from '../../types/redux';

export const selectUserData = (state: TApplicationState) => {
  return state.user.data;
};
